const TransporterEmailType = {
  FORGOT_PASSWORD: 'forgot_password',
  RFQ_CREATE: 'rfq_create',
  RFQ_EXPIRY_REMINDER: 'rfq_expiry_reminder',
  SLA_ACCEPTANCE_REMINDER: 'sla_acceptance_reminder',
  SLA_ASSIGN_REMINDER: 'sla_assign_reminder',
  SLA_ARRIVAL_REMINDER: 'sla_arrival_reminder',
  ACCEPT_RFQ_CANCELLED: 'accept_rfq_cancelled',
  ACCEPT_RFQ: 'accept_rfq',
  REJECT_RFQ: 'reject_rfq',
  REQUIREMENT_DATE_CHANGED: 'requirement_date_change_reminder',
  GRN_REPORT_RELEASE: 'grn_report_release_reminder',
  SLA_ACCEPTANCE_BREACH: 'sla_acceptance_breach',
  TWO_FACTOR_AUTH_OTP: 'two_factor_auth_otp',
};

const TransporterEmailSubject = {
  ACCEPT_RFQ_CANCELLED: 'Indent Cancelled!',
  ACCEPT_RFQ: 'Quote Accepted!',
  REJECT_RFQ: 'Quote Rejected!',
  REQUIREMENT_DATE_CHANGED: 'Vehicle Requirement Date Changed!',
  GRN_REPORT_RELEASE: 'Indent ID #firstArgument# has been delivered to #secondArgument#!',
};

const TransporterEmailDateFormat = 'hh:mm A';

module.exports = { TransporterEmailType, TransporterEmailSubject, TransporterEmailDateFormat };
